import { Component, OnInit } from '@angular/core';
import { WalkaroundQuestion } from '../../models/walkaround-question.model';
import { ActivatedRoute } from '@angular/router';
import { WalkaroundQuestionValidatorService } from '../../validators/walkaround-question-validator.service';
import { WalkaroundQuestionService } from '../../services/walkaround-question.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-walkaround-questions-edit',
    templateUrl: './walkaround-questions-edit.component.html',
    styleUrls: ['./walkaround-questions-edit.component.scss'],
    standalone: false
})
export class WalkaroundQuestionsEditComponent implements OnInit {

  question: WalkaroundQuestion = new WalkaroundQuestion();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private questionValidator: WalkaroundQuestionValidatorService,
    private questionService: WalkaroundQuestionService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadQuestion(+params['id']);
    })
  }

  loadQuestion(id: number): void {
    this.questionService.getWalkaroundQuestionById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401){return e;}
      this.isServerError = true;
      return e;
    }))
    .subscribe((question: WalkaroundQuestion) => {
      this.question = question;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.questionValidator.isValid(this.question)) {
      this.questionService.updateWalkaroundQuestion(this.question)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }

}
